import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import i18n from 'kodyl-js/i18n/react';
import { imageUrl } from '../utils/image-url';

@connect(({ dwelling: { lastDwelling } }) => ({ data: lastDwelling }))
@i18n
class LastDwelling extends Component {
  pageText = page => {
    if (page === 'signup') {
      return this.i18n(
        'You are almost there! Signup to see the contact details for this dwelling.'
      );
    }
    if (page === 'login') {
      return this.i18n(
        'You are almost there! Login to see the contact details for this dwelling.'
      );
    }
    if (page === 'subscription') {
      return this.i18n(
        'You are almost there! Subscribe to see the contact details for this dwelling.'
      );
    }
  };

  render() {
    const { data, page } = this.props;
    if (!data) {
      return null;
    }

    const link = `/vis/${data.dwellingId}`;
    const image = data.images[0];

    return (
      <div className="last-dwelling-container">
        <div
          className={`alert alert-info last-dwelling-alert${
            image ? ' has-img' : ''
          }`}
          role="alert"
          style={{ marginBottom: '6px' }}
        >
          {image ? (
            <Link
              to={link}
              className="last-dwelling-img"
              style={{ backgroundImage: `url('${imageUrl(image)}')` }}
            />
          ) : null}
          <Link className="alert-link" to={link}>
            <strong>{data.headline}</strong>
          </Link>
          <br />
          {this.pageText(page)}
        </div>
      </div>
    );
  }
}

export default LastDwelling;
